import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  const breadcrumbStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `https://moviewise91.github.io${item.href}` : undefined,
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbStructuredData) }}
      />
      <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-500 py-3 overflow-x-auto whitespace-nowrap">
        <ol className="flex items-center space-x-1">
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <span className="mx-1 text-foreground-300" aria-hidden="true">
                  <i className="ri-arrow-right-s-line text-xs"></i>
                </span>
              )}
              {item.href ? (
                <Link
                  to={item.href}
                  className="hover:text-primary-500 transition-colors duration-200"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-800 font-medium">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}